export const INPUT_PARAMS = {
  number: {
    label: '文字数',
    parameter: 'number',
    type: 'textarea',
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/Products/inputParams.js